import { Row, Block } from 'jsxstyle';
import { Button } from './Button';
import * as React from 'react';

const TextBox: React.SFC<any> = props => <Block {...props} padding={16} />;

export const ChangePassword = ({ onCancel, onSuccess }: any) => {
    return (
        <TextBox>
            <Block component="p" marginBottom={8}>
                To change your password you need to click a link. We will send
                this link to your registered email address.
            </Block>
            <Block component="p" marginBottom={32}>
                {' '}
                Are you sure you want to change your password?{' '}
            </Block>
            <Row justifyContent="space-around">
                <Button type="cancel" onClick={onCancel}>
                    No
                </Button>
                <Button type="success" onClick={onSuccess}>
                    Yes
                </Button>
            </Row>
        </TextBox>
    );
};
export const PasswordChanged = ({ onComplete }: any) => {
    return (
        <TextBox>
            <Block component="p" marginBottom={8}>
                Great! Check your inbox.
            </Block>
            <Block component="p" marginBottom={32}>
                Contact{' '}
                <a href="mailto:support@laud-media.com">
                    support@laud-media.com
                </a>
                if you need help or have questions about changing your password.
            </Block>
            <Row justifyContent="center">
                <Button onClick={onComplete} type="success">
                    Ok
                </Button>
            </Row>
        </TextBox>
    );
};
export const PasswordChangeFailed = ({ onComplete }: any) => {
    return (
        <TextBox>
            <Block component="p" marginBottom={8} fontWeight="bold">
                Sorry, an error occurred!
            </Block>
            <Block component="p" marginBottom={32}>
                Contact{' '}
                <a href="mailto:support@laud-media.com">
                    support@laud-media.com
                </a>
                if the problem persists
            </Block>
            <Row justifyContent="center">
                <Button onClick={onComplete} type="success">
                    Ok
                </Button>
            </Row>
        </TextBox>
    );
};



// WEBPACK FOOTER //
// ./src/PasswordChange.tsx